import React from "react";
import { docsColors } from "@/lib/docs-theme";
import CopyButton from "./CopyButton";

interface DocCodeBlockProps {
  children: React.ReactNode;
  className?: string;
  copyText?: string;
}

export default function DocCodeBlock({ children, className = "", copyText }: DocCodeBlockProps) {
  return (
    <div
      className={`${docsColors.bg.code} ${docsColors.text.onDark} rounded p-4 font-mono text-sm relative ${className}`}
    >
      <div className="overflow-x-auto">{children}</div>
      {copyText && <CopyButton text={copyText} className="absolute top-3 right-3" />}
    </div>
  );
}
